import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { VisitaPage } from '../pages/VisitaPage';
import '../styles.css';

const container = document.getElementById('app')!;
createRoot(container).render(
  <StrictMode>
    <VisitaPage />
  </StrictMode>,
);
